import React from 'react';
import { SvgIcon } from '../../';
function LogoutIcon(props) {
    return (React.createElement(SvgIcon, { ...props },
        React.createElement("path", { fill: "none", stroke: "currentColor", strokeLinecap: "round", d: "M11.53 12h10.22M22.25 12l-4 4M22.25 12l-4-4M18.11 3.5H3M18.11 20.5H3M3 20.5v-17" })));
}
export default LogoutIcon;
//# sourceMappingURL=LogoutIcon.js.map